import {
    Box,
    Button,
    Divider,
    Drawer,
    IconButton,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Menu,
    ListItemIcon,
    ListItemText,
    Checkbox,
} from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined"
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const OrderManagement = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<any | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOrder, setMenuOrder] = useState<any | null>(null);
    const [selectedOrders, setSelectedOrders] = useState<string[]>([]);

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>, order: any) => {
        setAnchorEl(event.currentTarget);
        setMenuOrder(order);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setMenuOrder(null);
    };

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedOrders(orderData.map((o) => o.orderId));
        } else {
            setSelectedOrders([]);
        }
    };

    const toggleSelectItem = (id: string) => {
        setSelectedOrders((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };


    const orderData = [
        {
            orderId: "ORD-2025-001",
            store: "TechHub Electronics",
            vendor: {
                name: "TechHub Electronics",
                email: "support@techhub.com",
            },
            customer: {
                name: "Mohammed Al Mansoori",
                email: "mohammed@example.com",
            },
            date: "12/12/2025",
            time: "4:47:53 PM",
            total: "AED 447.50",
            payment: "Paid",
            paymentMethod: "Card",
            priority: "High",
            risk: "Safe",
            status: "Delivered",
        },
        {
            orderId: "ORD-2025-002",
            store: "TechHub Electronics",
            vendor: {
                name: "TechHub Electronics",
                email: "sales@techhub.com",
            },
            customer: {
                name: "Sara Ahmed",
                email: "sara@example.com",
            },
            date: "12/12/2025",
            time: "4:47:53 PM",
            total: "AED 287.50",
            payment: "Paid",
            paymentMethod: "Cash",
            priority: "Medium",
            risk: "Moderated",
            status: "Shipped",
        },
    ];



    const handleChangeCity = (event: SelectChangeEvent) => {
        // For now, this is global. Ideally, use row-level state.
    };

    const handleViewOrder = (order: any) => {
        setSelectedOrder(order);
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
        setSelectedOrder(null);
    };

    return (
        <>
            <div className="main_title">
                <h1>Order Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Order Management
                </p>
            </div>
            <div className="stats_boxes gap_m">
                {/* Total Orders */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            120
                            <p>Total Orders</p>
                        </h2>
                        <figure className="blue">
                            <Inventory2OutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>12.5% increase</span>
                    </div>
                </a>

                {/* Total Revenue */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            AED 250,000
                            <p>Total Revenue</p>
                        </h2>
                        <figure className="green">
                            <AttachMoneyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>8.3% growth this month</span>
                    </div>
                </a>

                {/* Pending Orders */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            12
                            <p>Pending</p>
                        </h2>
                        <figure className="warning">
                            <HourglassEmptyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight negative">
                        <span>5% higher than last week</span>
                    </div>
                </a>

                {/* AVG Fulfilment Time */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            45 min
                            <p>AVG Fulfilment Time</p>
                        </h2>
                        <figure className="blue">
                            <AutorenewOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight neutral">
                        <span>Within target range</span>
                    </div>
                </a>
            </div>
            <div className="table_flex mt_20">
                <div className="lt">
                    {selectedOrders.length > 0 && (
                        <div className="bulk_action_bar" style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '10px 16px',
                            background: '#fff',
                            borderRadius: '8px',
                            marginBottom: '16px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <Button
                                variant="contained"
                                sx={{
                                    background: '#c49133',
                                    '&:hover': { background: '#b0812b' },
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    fontWeight: 600
                                }}
                                endIcon={<KeyboardArrowDownIcon />}
                            >
                                {selectedOrders.length} Selected
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: '#4b5563',
                                    borderColor: '#d1d5db',
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                                }}
                            >
                                All orders at risk
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: '#4b5563',
                                    borderColor: '#d1d5db',
                                    textTransform: 'none',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '14px',
                                    '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                                }}
                            >
                                Bulk notify vendors
                            </Button>
                            <Box
                                component="a"
                                onClick={() => setSelectedOrders([])}
                                sx={{
                                    cursor: "pointer",
                                    color: "#3b82f6",
                                    ml: 'auto',
                                    fontSize: "14px",
                                    textDecoration: 'none',
                                    '&:hover': { textDecoration: 'underline' }
                                }}
                            >
                                Cancel
                            </Box>
                        </div>
                    )}

                    <div className="cards ">
                        <div className="table_header">
                            <div className="left_s">
                                <Box className="search_box">
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search orders..."
                                    />
                                </Box>
                                <div className="form">
                                    <div className="control_group">
                                        <input type="date" />
                                    </div>
                                    <select>
                                        <option value="all">Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="confirmed">Confirmed</option>
                                        <option value="processed">Processed</option>
                                        <option value="shipped">Shipped</option>
                                        <option value="delivered">Delivered</option>
                                        <option value="cancelled">Cancelled</option>
                                        <option value="refunded">Refunded</option>
                                    </select>
                                    <select>
                                        <option value="all">Vendor</option>
                                        <option value="techhub">TechHub Electronics</option>
                                        <option value="urban">UrbanCare</option>
                                        <option value="fashion">Fashion Hub</option>
                                    </select>
                                    <select>
                                        <option value="all">Customer</option>
                                        <option value="mohammed">Mohammed Al Mansoori</option>
                                        <option value="sara">Sara Ahmed</option>
                                        <option value="john">John Doe</option>
                                    </select>
                                </div>
                            </div>
                            <div className="right_s"></div>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                indeterminate={selectedOrders.length > 0 && selectedOrders.length < orderData.length}
                                                checked={orderData.length > 0 && selectedOrders.length === orderData.length}
                                                onChange={handleSelectAll}
                                            />
                                        </TableCell>
                                        <TableCell>Order</TableCell>
                                        <TableCell>Vendor Details</TableCell>
                                        <TableCell>Customer Details</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Total</TableCell>
                                        <TableCell>Payment</TableCell>
                                        <TableCell>Payment Method</TableCell>
                                        <TableCell>Priority</TableCell>
                                        <TableCell>Risk</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>

                                </TableHead>

                                <TableBody>
                                    {orderData.map((order, index) => (
                                        <TableRow key={index} hover selected={selectedOrders.includes(order.orderId)}>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={selectedOrders.includes(order.orderId)}
                                                    onChange={() => toggleSelectItem(order.orderId)}
                                                />
                                            </TableCell>
                                            {/* Order */}
                                            <TableCell>
                                                <div className="user_block">
                                                    <p> <b >{order.orderId}</b>
                                                        {order.store}</p>
                                                </div>

                                            </TableCell>
                                            {/* Vendor */}
                                            <TableCell>
                                                <div className="user_block">
                                                    <p>
                                                        <b>{order.vendor.name}</b>
                                                        {order.vendor.email}
                                                    </p>
                                                </div>
                                            </TableCell>

                                            {/* Customer */}
                                            <TableCell>
                                                <div className="user_block">
                                                    <p> <b >{order.customer.name}</b>
                                                        {order.customer.email}</p>
                                                </div>
                                            </TableCell>

                                            {/* Date */}
                                            <TableCell>
                                                <p>{order.date}</p>
                                                <span className="sub_text">{order.time}</span>
                                            </TableCell>

                                            {/* Total */}
                                            <TableCell>
                                                <p className="fw_600">{order.total}</p>
                                            </TableCell>

                                            {/* Payment */}
                                            <TableCell>
                                                <span className="badge1 success">paid</span>
                                            </TableCell>
                                            <TableCell>
                                                <span className="sub_text fw_600">{order.paymentMethod}</span>
                                            </TableCell>

                                            <TableCell>
                                                <span className={`badge1 ${order.priority.toLowerCase()}`}>
                                                    {order.priority}
                                                </span>
                                            </TableCell>

                                            <TableCell>
                                                <span className={`badge1 ${order.risk === 'Safe' ? 'success' : order.risk === 'Moderated' ? 'warning' : 'danger'}`}>
                                                    {order.risk}
                                                </span>
                                            </TableCell>

                                            {/* Status */}
                                            <TableCell>
                                                <span className={`badge1 ${order.status.toLowerCase()}`}>
                                                    {order.status}
                                                </span>
                                            </TableCell>

                                            {/* Actions */}
                                            <TableCell>
                                                <IconButton
                                                    id="basic-button"
                                                    aria-controls={open ? 'basic-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={open ? 'true' : undefined}
                                                    onClick={(e) => handleClick(e, order)}
                                                >
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row warning">
                                <div className="ai_sku_info">
                                    <h5 style={{ color: '#92400e' }}>Top Delay: QuickFix Services</h5>
                                    <p>SLA breach predicted in 12 mins</p>
                                </div>
                                <button className="ai_action_btn">Alert ▾</button>
                            </div>

                            <Box sx={{ mt: 2, mb: 1 }}>
                                <Button
                                    size="small"
                                    variant="text"
                                    sx={{ textTransform: 'none', fontSize: '12px', fontWeight: 600, color: '#3b82f6' }}
                                    onClick={() => { }}
                                >
                                    View all risk orders ›
                                </Button>
                            </Box>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>Product Inventory Risk</h5>
                                    <p>7 SKUs low on stock</p>
                                </div>
                                <button className="ai_action_btn">View ▾</button>
                            </div>
                        </div>

                        <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid #f1f5f9' }}>
                            <Button
                                fullWidth
                                variant="contained"
                                className="btn_primary"
                                sx={{ textTransform: 'none', py: 1 }}
                            >
                                Open AI Insights Report
                            </Button>
                        </Box>
                    </div>
                </div>
            </div>

            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={handleCloseDrawer}
                PaperProps={{ sx: { width: 400 } }}
            >
                {selectedOrder && (
                    <Box p={3}>
                        <h2>Order Details</h2>
                        <Divider sx={{ mb: 2 }} />

                        <div
                            className=" p-drawer-content"
                        >
                            <div className="order_detail_drawer view_page">
                                {/* Order Header */}
                                <div className="border_box">
                                    <div className="head hd_5">
                                        <h2>#Order_001</h2>
                                        <span className="status_btn c_warning">Pending</span>
                                    </div>
                                    <div className="body">
                                        <div className="gap_p">
                                            <div className="w_100 flex">
                                                <h6>Order Date/Time</h6>
                                                <p>02 August 2025, 03:30 PM</p>
                                            </div>
                                            <div className="w_100 flex">
                                                <h6>Order Type</h6>
                                                <p>Pickup</p>
                                            </div>
                                            <div className="w_100 flex">
                                                <hr />
                                            </div>
                                            <div className="w_100">
                                                <h6>Pickup Date & Time</h6>
                                                <p>06 August 2025, 03:30 PM</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Pickup and Delivery Options */}
                                <div className="border_box">
                                    <div className="head hd_5">
                                        <h2>Pickup and Deliver Options</h2>
                                    </div>
                                    <div className="body">
                                        <div className="gap_p v2">
                                            <div className="w_100">
                                                <h6>Pickup Store</h6>
                                                <p>Saginaw Supercenter</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Items Details */}
                                <div className="border_box">
                                    <div className="head hd_5">
                                        <h2>Items Details</h2>
                                    </div>
                                    <div className="body">
                                        <div className="product_box">
                                            <figure>
                                                <img
                                                    alt="place_img"
                                                    src="static/images/placeholder.png"
                                                />
                                            </figure>
                                            <div className="info">
                                                <div className="hd_6">
                                                    <h3>ZARA</h3>
                                                    <h3>Men Sports Shoes</h3>
                                                    <p>
                                                        <strong className="c_success">$1200</strong>
                                                        <span>x1</span>
                                                    </p>
                                                </div>
                                                <div className="gap_p">
                                                    <div className="w_100 flex">
                                                        <h6>Colour:</h6>
                                                        <p>Red</p>
                                                    </div>
                                                    <div className="w_100 flex">
                                                        <h6>Size:</h6>
                                                        <p>L</p>
                                                    </div>
                                                    <div className="w_100 flex">
                                                        <h6>Delivery Fee:</h6>
                                                        <p>$15</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="product_box">
                                            <figure>
                                                <img
                                                    alt="place_img"
                                                    src="static/images/placeholder.png"
                                                />
                                            </figure>
                                            <div className="info">
                                                <div className="hd_6">
                                                    <h3>ZARA</h3>
                                                    <h3>Men Sports Shoes</h3>
                                                    <p>
                                                        <strong className="c_success">$1200</strong>
                                                        <span>x1</span>
                                                    </p>
                                                </div>
                                                <div className="gap_p">
                                                    <div className="w_100 flex">
                                                        <h6>Colour:</h6>
                                                        <p>Red</p>
                                                    </div>
                                                    <div className="w_100 flex">
                                                        <h6>Size:</h6>
                                                        <p>L</p>
                                                    </div>
                                                    <div className="w_100 flex">
                                                        <h6>Delivery Fee:</h6>
                                                        <p>$15</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* User Details */}
                                <div className="border_box">
                                    <div className="head hd_5">
                                        <h2>User Details</h2>
                                    </div>
                                    <div className="body">
                                        <div className="user_block big">
                                            <figure>
                                                <img alt="place_img" src="static/images/admin_icon.png" />
                                            </figure>
                                            <p>
                                                <b>Alice Johnson</b>
                                                <span>alice.johnson@example.com</span>
                                                <span>+91 9876543210</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Driver Details */}
                                <div className="border_box">
                                    <div className="head hd_5">
                                        <h2>Driver Details</h2>
                                    </div>
                                    <div className="body">
                                        <div className="user_block big">
                                            <figure>
                                                <img alt="place_img" src="static/images/admin_icon.png" />
                                            </figure>
                                            <p>
                                                <b>Rajesh Kumar</b>
                                                <span>rajesh.kumar@example.com</span>
                                                <span>+91 9876543210</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Billing Summary */}
                                <div className="border_box bill_summary">
                                    <div className="head hd_5">
                                        <h2>Billing Summary</h2>
                                        <p>
                                            <span className="c_primary">Paid by Card</span>
                                        </p>
                                    </div>
                                    <div className="body">
                                        <div className="gap_p">
                                            <div className="w_100 ">
                                                <h6>Subtotal</h6>
                                                <p>$849,159</p>
                                            </div>
                                            <div className="w_100 ">
                                                <h6>Total discount</h6>
                                                <p>-$36,808</p>
                                            </div>
                                            <div className="w_100 ">
                                                <h6>Taxes and Fees</h6>
                                                <p>$20,000</p>
                                            </div>
                                            <div className="w_100 ">
                                                <h6>Delivery</h6>
                                                <p>$25,000</p>
                                            </div>
                                            <div className="w_100 ">
                                                <h6>
                                                    <span className="c_warning">Promo</span>
                                                </h6>
                                                <p>
                                                    <span className="c_warning">-$15,000</span>
                                                </p>
                                            </div>
                                            <div className="w_100 ">
                                                <hr />
                                            </div>
                                            <div className="w_100 fs_big ">
                                                <h6>Total</h6>
                                                <p>
                                                    <strong className="c_success">$879,159</strong>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Divider sx={{ my: 2 }} />

                        <Button
                            fullWidth
                            className="btn_primary"
                            onClick={handleCloseDrawer}
                        >
                            Close
                        </Button>
                    </Box>
                )}
            </Drawer>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <ReportProblemIcon sx={{ color: '#d32f2f' }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Escalate Order</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <WarningAmberIcon sx={{ color: '#ed6c02' }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Force Vendor Follow-Up</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <PauseCircleOutlineIcon sx={{ color: '#ff9800' }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Put on Hold</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => {
                    handleClose();
                    navigate("view");
                }}>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View Order Details</ListItemText>
                </MenuItem>
            </Menu>

        </>
    );
};

export default OrderManagement;
